import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftEntraId = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.802 17.0308C7.19 17.2728 7.835 17.5418 8.517 17.5418C9.138 17.5418 9.715 17.3618 10.193 17.0548C10.193 17.0548 10.194 17.0548 10.195 17.0538L12 15.9258V19.9988C11.714 19.9988 11.426 19.9208 11.176 19.7648L6.802 17.0308Z",
			fill: "#225086"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.853 4.507L3.353 12.967C2.774 13.621 2.925 14.609 3.676 15.078C3.676 15.078 6.452 16.813 6.802 17.032C7.19 17.274 7.835 17.543 8.517 17.543C9.138 17.543 9.715 17.363 10.193 17.056C10.193 17.056 10.194 17.056 10.195 17.055L12 15.927L7.636 13.199L12.001 8.275V4C11.577 4 11.153 4.169 10.853 4.507Z",
			fill: "#66DDFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.63599 13.1974L7.68799 13.2294L12 15.9254H12.001V8.27444L12 8.27344L7.63599 13.1974Z",
			fill: "#CBF8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.324 15.078C21.075 14.609 21.226 13.621 20.647 12.967L15.726 7.416C15.329 7.231 14.884 7.125 14.413 7.125C13.488 7.125 12.661 7.524 12.111 8.151L12.002 8.274L16.366 13.198L12.001 15.926V19.999C12.288 19.999 12.574 19.921 12.824 19.765L20.324 15.077V15.078Z",
			fill: "#074793"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.001 4V8.275L12.11 8.152C12.66 7.525 13.487 7.126 14.412 7.126C14.884 7.126 15.328 7.233 15.725 7.417L13.146 4.508C12.847 4.17 12.423 4.001 12 4.001L12.001 4Z",
			fill: "#0294E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.365 13.2003L12.001 8.27734V15.9273L16.365 13.2003Z",
			fill: "#96BCC2"
		})
	]
});
export default SvgMicrosoftEntraId;
